<template>
  <div class="root">
    <div class="title">
      {{ jiekoudata.title }}
      <!-- 1=正在招商,2=招商结束 -->
      <span class="invest_tips">{{
        jiekoudata.status == 1 ? "正在招商" : "招商结束"
      }}</span>
    </div>
    <div class="title-time">发布时间：{{ jiekoudata.createTime }}</div>
    <div class="top-content">
      <div class="c1 c2">
        <div class="c1l">发布单位</div>
        <div class="c1r">{{ jiekoudata.dept }}</div>
        <div class="c1l">招商类型</div>
        <div
          class="c1r"
          v-for="(dict, index) in dicts"
          :key="dict.dictCode"
          v-show="dict.dictValue == jiekoudata.type"
        >
          {{ dict.dictLabel }}
        </div>
      </div>
      <div class="c1 c2">
        <div class="c1l">联系人</div>
        <div class="c1r">{{ jiekoudata.linkman }}</div>
        <div class="c1l">咨询电话</div>
        <div class="c1r">
          {{
            isLogin
              ? jiekoudata.linkPhone
              : jiekoudata.linkPhone.slice(0, 3) +
                "*****" +
                jiekoudata.linkPhone.slice(-3)
          }}
        </div>
      </div>
      <div class="c1">
        <div class="c1l">评估价值(元)</div>
        <div class="c1r">{{ jiekoudata.estimated }}</div>
        <div class="c1l"></div>
        <div class="c1r"></div>
      </div>
      <div class="yixiang" @click="yixiang">我有意向</div>
    </div>
    <div class="main-content">
      <div class="hui">
        <!-- <div @click="getDetailActive = 1" :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"><a href="#zsss"
            :class="getDetailActive == 1 ? 'getDetail1' : ''">招商详情</a> -->
        <a
          href="#zsss"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
          @click="getDetailActive = 1"
          >招商详情</a
        >

        <a
          href="#zspi"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
          @click="getDetailActive = 2"
          >招商图片</a
        >
      </div>
      <div class="xiangqing">
        <div class="footerTitle" id="zsss"></div>
        <div class="fengexian">
          <el-divider>招商详情</el-divider>
        </div>
        <p v-html="jiekoudata.detail"></p>
      </div>
      <div class="xiangqing">
        <div class="footerTitle" id="zspi"></div>
        <div class="fengexian">
          <el-divider>招商图片</el-divider>
        </div>

        <div class="imgcontent">
          <el-image
            v-for="(item, index) in jiekoudata.imgList"
            :key="index"
            style="
              width: 48%;
              height: auto;
              margin-left: 10px;
              margin-bottom: 10px;
            "
            :src="item"
            :preview-src-list="jiekoudata.imgList"
          >
          </el-image>
        </div>
      </div>
    </div>
    <el-dialog
      title="意向填写"
      :visible.sync="dialogVisible"
      width="1500px"
      @close="quxiaotianxie"
    >
      <div class="miaoshu">
        <div>意向描述</div>
        <div>1、如果对此招商信息有意向，请填写您的联系方式。</div>
        <div>
          2、您知晓并同意，那么您所填写的联系方式将会发送至处置单位及相关服务提供方，用于与您进一步沟通联系。
        </div>
      </div>
      <div class="shenqingform">
        <el-form
          ref="ruleForm"
          :model="form"
          label-width="200px"
          :rules="rules"
        >
          <el-form-item label="姓名/单位名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>

          <el-form-item label="验证码" prop="captcha">
            <div class="yanz">
              <div>
                <el-input
                  v-model="form.captcha"
                  style="width: 400px"
                ></el-input>
              </div>
              <div class="login-code" width="100%" @click="refreshCode">
                <!--验证码组件-->
                <dentify :identifyCode="identifyCode"></dentify>
              </div>
            </div>

            <!-- <img :src="yanzheng.src" alt="" class="yanzhengma" @click="yixiang"> -->
          </el-form-item>

          <el-form-item label="意向说明" prop="detail">
            <el-input v-model="form.detail" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="tijiaoyixiang" @click="cofirmtijiao">提交意向</div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="cofirmtijiao">确 定</el-button>
  </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { InvestListDetail, feedback } from "../api/资产招商.js"
import { getDicts } from '../api/mian.js'
import { checkToken } from "../api/login.js"
import dentify from "./Dentify"
import { cityDetail } from '../util/mainOption.js'
export default {
  components: {
    dentify,
  },
  data () {
    var validatorPhone = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"))
      } else {
        callback()
      }
    }
    return {
      dicts: [],//字典
      jiekoudata: {},
      getDetailActive: 1,
      dialogVisible: false,
      form: {
        name: "",
        phone: "",
        captcha: "",
        detail: "",
      },
      isLogin: false,

      yanzheng: {},
      id: '',//招商id
      rules: {
        name: [
          { required: true, message: '请输入姓名/单位名称', trigger: 'blur' },

        ],
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },

        ],
        detail: [
          { required: true, message: '请输入意向说明', trigger: 'blur' },

        ],
      },
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
      identifyCode: "", //验证码图片内容


    }
  },
  created () {
    this.id = this.$route.query.id
    InvestListDetail({ id: this.id }).then(res => {
      this.jiekoudata = res.data.data
    })
    getDicts('invest_type').then(res => {
      this.dicts = res.data.data
    })



  },
  mounted () {
    // 初始化验证码
    // this.identifyCode = "";
    // //参数：（1）随机串内容。（2）验证码显示位数
    // this.makeCode(this.identifyCodes, 4);
    checkToken().then(res => {
      console.log("鉴证书身份认证", res)
      if (res.data.code == 200) {
        this.isLogin = true
      }
    })
  },
  methods: {
    //关闭填写意向弹窗
    quxiaotianxie () {
      this.$refs.ruleForm.resetFields()
      this.dialogVisible = false
    },
    yixiang () {
      let token = localStorage.getItem("token")
      if (token) {
        checkToken().then(res => {

          if (res.data.code == 200) {
            this.refreshCode()

            this.dialogVisible = true
          } else {
            this.$message.warning('请重新登录')
            if (cityDetail.homeShowLogin) {
              this.$router.push('/')
            } else {
              this.$router.push('/login')
            }

          }
        })
      } else {
        this.$message.warning('请先登录')
        if (cityDetail.homeShowLogin) {
          this.$router.push('/')
        } else {
          this.$router.push('/login')
        }
      }


    },
    cofirmtijiao () {

      if (this.identifyCode != this.form.captcha) {
        this.$message.warning('请输入正确的验证码')
        return
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // this.form.captcha_id = this.yanzheng.captcha_id
          this.form.investId = this.id
          console.log(this.form)

          feedback(this.form).then(res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.msg)
              this.dialogVisible = false
            } else {
              this.$message.error(res.data.msg)
              this.refreshCode()
            }
          })
        } else {
          this.$message.warning('请完整填写信息')
          return false
        }
      })





    },
    getYanzheng () {
      this.yanzheng = this.ajax_id1('api/invest/captcha').data
    },
    // 重置验证码
    refreshCode () {
      this.identifyCode = ""
      this.makeCode(this.identifyCodes, 4)
    },
    //获取验证码的值
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        //通过循环获取字符串内随机几位
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    //随机数字：用于当角标拿字符串的值
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },

  }
}
</script>

<style scoped>
.imgcontent {
  display: flex;
  /* justify-content: s; */
  flex-wrap: wrap;
}

.yanz {
  display: flex;
}

.tijiaoyixiang {
  background-color: #ff5353;
  width: 200px;
  margin: 20px auto;
  color: #fff;
  height: 60px;
  line-height: 60px;
  font-size: 24px;
  border-radius: 10px;
  cursor: pointer;
}

.shenqingform {
  margin: 30px 0;
  padding: 30px;
  text-align: left;
}

.yanzhengma {
  width: auto;
  height: 60px;
  margin-left: 30px;
  cursor: pointer;
}

.root >>> .el-dialog__headerbtn {
  font-size: 34px;
}

.root >>> .el-form-item__error {
  font-size: 20px;
}

.root >>> .el-dialog__close {
  color: #fff;
}

.root >>> .el-dialog__header {
  background-color: #6681ea;
  height: 50px;
  color: #fff;
}

.root >>> .el-form-item__label {
  font-size: 24px;
}

.root >>> .el-form-item__content {
  font-size: 24px;
}

.root >>> .el-input {
  font-size: 24px;
}

.root >>> .el-input__inner {
  height: 50px;
  line-height: 50px;
}

.root >>> .el-textarea {
  font-size: 24px;
}

.root >>> .el-dialog__title {
  display: block;
  line-height: 50px;
  font-size: 38px;
  color: #fff;
}

.root >>> .el-dialog__body {
  font-size: 24px;
}

.root {
  /* border: 1px solid red; */
  width: 1854px;
  margin: 0 auto;
  background-color: #fff;
  text-align: center;
  padding: 50px 0;
}

.miaoshu {
  text-align: left;
  background-color: #e6ebff;
  padding: 30px;
  border-radius: 10px;
  color: #292929;
}

.miaoshu > div {
  height: 50px;
  line-height: 50px;
}

.title {
  font-size: 38px;

  color: #292929;
}

.title-time {
  font-size: 20px;
  color: #666;
  margin-top: 20px;
  padding-bottom: 30px;
  border-bottom: #999999 1px solid;
}

.top-content {
  margin: 50px 0;
  padding-bottom: 40px;
  border-bottom: #6681ea 5px solid;
}

.c1 > div {
  line-height: 90px;
  flex: 1;
}

.c1l {
  background-color: #d6deff;
}

.c1 {
  display: flex;
  border: #999999 1px solid;
  font-weight: 500;
  font-size: 30px;
  /* align-items: 70px; */
  font-family: Microsoft YaHei;
  height: 90px;
}

.c2 {
  border-bottom: none;
}

.yixiang {
  width: 260px;
  height: 70px;
  background-color: #ff5353;
  font-size: 32px;
  line-height: 70px;
  color: #fff;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 40px;
  cursor: pointer;
}

.main-content {
}

.hui {
  height: 90px;
  background-color: #f1f1f1;
  display: flex;
  font-size: 30px;
  border-radius: 10px;
}

.hui > div {
  line-height: 90px;
  width: 200px;
  cursor: pointer;
  /* background-color: #fff; */
}

.xiangqing {
  margin-top: 20px;
}

.xiangqing >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #ec222f;
  list-style: armenian;
}

.getdetail {
  /* font-size: 24px; */
  padding: 0 30px;
  font-weight: 600;
  line-height: 90px;
  opacity: 0.5;
  /* border: 1px solid red; */
}

.getDetail {
  /* font-size: 24px; */
  padding: 0 30px;
  line-height: 90px;
  border-bottom: 5px solid #6681ea;
  background-color: white;
}

.footerTitle {
  font-size: 36px;
  height: 15px;
  /* border: #67C23A 1px solid; */
  /* margin-bottom: 40px; */
  color: #ec222f;
  /* list-style: armenian; */
}

.fengexian {
  margin-bottom: 50px;
}

.invest_tips {
  background: #fa6201;
  font-size: 20px;
  padding: 5px;
  color: #fff;
  border-radius: 20% 20% 20% 0;
}

.login-code {
  /* border: 1px solid red; */
  width: 100px;
  margin-left: 20px;
  cursor: pointer;
}

.c1r {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>